import styled, { css } from 'styled-components';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { getBreakpointsForHeaderVersion } from 'src/components/ZillowNavbar/utils/getBreakpointsForHeaderVersion';
import { ZillowSVGImage } from '../../common/ZillowSVGImage/ZillowSVGImage';
import { InternalLogoProps } from './InternalLogoProps';

export const DesktopZillowLogoSVGImage = styled(ZillowSVGImage)<InternalLogoProps>`
    width: 160px;
    height: 35px;
    display: block;
    ${({ version, isMobileNavOpen }) => {
        switch (version) {
            case HEADER_VERSIONS.TRANSPARENT_MOBILE_ONLY: {
                if (isMobileNavOpen) {
                    return css`
                        @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
                            height: 25px;
                            width: 120px;
                        }
                    `;
                }
                return css`
                    @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
                        display: none;
                    }
                `;
            }
            case HEADER_VERSIONS.DEFAULT: {
                return css`
                    @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
                        height: 25px;
                        width: 120px;
                    }
                `;
            }
        }
    }}
`;
